// extracted by mini-css-extract-plugin
export var active = "_az-d";
export var blink = "_az-e";
export var container = "_az-5";
export var controls = "_az-0";
export var controlsRight = "_az-1";
export var fakeCursor = "_az-c";
export var hidden = "_az-b";
export var quillContainerSmall = "_az-7";
export var quillEditor = "_az-6";
export var quillEditorSmall = "_az-8";
export var quillFormatButtons = "_az-a";
export var quillToolbar = "_az-9";
export var removePadding = "_az-2";
export var state = "_az-3";
export var stateTitle = "_az-4";